import PayAndBook from './pay-and-book';

export default PayAndBook;
